import {useCallback} from 'react';

import {useOnboardingModalState} from '../../app/topBar/onboarding/onboardingContext';
import {useSharedWorkspaceTaskIsComplete} from '../admin/tasks/adminOnboardingTasks';

/*
 * Hooks.
 */

export function useMaybeOpenAdminWizard() {
  const {setIsAdminWizardOpen} = useOnboardingModalState();
  const isSharedWorkspaceTaskComplete = useSharedWorkspaceTaskIsComplete();

  return useCallback(() => {
    if (!isSharedWorkspaceTaskComplete) {
      setIsAdminWizardOpen(true);
      return true;
    }

    return false;
  }, [isSharedWorkspaceTaskComplete, setIsAdminWizardOpen]);
}
